<div class="row">
	<div class="col-lg-12">
		<div class="ibox float-e-margins">
			<div class="ibox-content">
				<form name="ActionForm" class="form-horizontal" role="form" novalidate>
					<!--START OPTIONS-->
					<!--SchoolID-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">School</label>
						<div class="col-sm-4 col-lg-3">
							<!-- <select class="form-control" name="SchoolID" (ngModelChange)="onSchoolChange($event)" [(ngModel)]="report.SchoolID">
                                <option value="" style="display:none;"></option>
                                <option *ngFor="let o of schoolList" [ngValue]="o.SchoolID">{{o.SchoolName}}</option>
                            </select> -->

							<caass-schoolselector [ShowAll]="false" [IsReport]="true" [ReportID]="235"> </caass-schoolselector>
						</div>
					</div>

					<!--STAFFTYPEID-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Staff Type</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="STAFFTYPEID" [(ngModel)]="report.STAFFTYPEID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of STAFFTYPEList" [ngValue]="o.PersonTypeID">
									{{ o.PersonTypeDesc }}
								</option>
							</select>
						</div>
					</div>

					<!--W_ID-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Show ID Number</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="W_ID" [(ngModel)]="report.W_ID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of W_List" [ngValue]="o.W_ID">
									{{ o.W_Name }}
								</option>
							</select>
						</div>
					</div>

					<!--W_HPhone-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Show Home Phone</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="W_HPhoneID" [(ngModel)]="report.W_HPhoneID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of W_HPhoneList" [ngValue]="o.W_HPhoneID">
									{{ o.W_HPhoneName }}
								</option>
							</select>
						</div>
					</div>

					<!--W_StaffType-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Show Staff Type</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="W_StaffTypeID" [(ngModel)]="report.W_StaffTypeID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of W_StaffTypeList" [ngValue]="o.W_StaffTypeID">
									{{ o.W_StaffTypeName }}
								</option>
							</select>
						</div>
					</div>

					<!--File Type-->
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label">Output File Type</label>
						<div class="col-sm-4 col-lg-3">
							<select class="form-control" name="OutputTypeID" [(ngModel)]="OutputTypeID">
								<option value="" style="display: none"></option>
								<option *ngFor="let o of OutputTypeList" [ngValue]="o.ID">
									{{ o.Desc }}
								</option>
							</select>
						</div>
					</div>

					<!--Submit Form-->
					<div class="hr-line-dashed"></div>
					<div class="form-group">
						<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
							{{ errorMessage }}
						</div>
					</div>
					<div class="form-group">
						<label class="col-sm-3 col-lg-2 control-label"></label>
						<div class="col-md-4 col-lg-3">
							<div name="Saveing" *ngIf="isProcessing" class="alert alert-info">Processing.Please wait...</div>
							<button name="btnSaving" *ngIf="!isProcessing" class="btn btn-primary" type="button" (click)="Print()">Print</button>
							<button
								name="btnMerge"
								*ngIf="!isProcessing"
								class="btn btn-primary"
								style="margin-left: 5px"
								type="button"
								(click)="MergeToGroup()"
							>
								Merge to Group
							</button>
						</div>
					</div>
				</form>
			</div>
		</div>
	</div>
</div>
